module.exports = __webpack_public_path__ + "img/head_img.ab974dda.png";